<template>
  <div>
    <div class="inner-wrapper">
      <span class="focus-logo"></span>
      <div class="brand-info-head">
        <span class="focus-title"></span>
        <Nav class="head-nav"></Nav>
      </div>
      <div class="brand-info-content">
        <div class="md-container">
          <span class="til"></span>
          <div class="info-wrap">
            <ul class="info-list">
              <li v-for="(item, index) in infoList" :key="index">
              <a :href="item.link" target="_blank" :title="item.title">
                <span class="art-name"> {{ item.title }} </span>
                <span class="art-date"> {{ item.date }} </span>
              </a>
            </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <Foot></Foot>
  </div>
</template>
<script>
import Foot from "../components/Foot.vue";
import Nav from "../components/Nav.vue";
export default {
  components: {
    Foot,
    Nav
  },
  computed: {
    infoList() {
      return this.$globalData.info
    }
  }
}
</script>
<style lang="less" scoped>
@media(max-width: 1200px) {
  .inner-wrapper {
    .brand-info-head{
      height: 65.067vw !important;
      .head-nav{
        bottom: 3.18vw!important;
      }
    }
    .brand-info-content{
      min-height:  50vh !important;
      padding-top: 3.88vw !important;
    }
    div.md-container {
      width: 100% !important;
      min-height: auto !important;
      .til{
        width: 32.28vw!important;
        height: 8.215vw !important;
        background: url(https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/info_til_m.png) no-repeat top center !important;
        background-size: 100% auto !important;
        right: 50% !important;
        transform: translate(50%) !important;
        top: 0 !important;
      }
      .info-wrap{
        padding: 16.68vw 0;
        .info-list{
          box-sizing: border-box;
          width: 100% !important;
          padding: 0 9.033vw !important;
          li{
            margin-bottom: 2.12vw !important;
          }
          a{
            font-size: 3.66vw !important;
            line-height: 4.2vw !important;
            .art-name{
              width: 58.5vw !important;
            }
          
          }
        }
      }
    }
  }
}
@media(max-width: 1560px) {
  .inner-wrapper {
    .md-container {
      width: 1200px !important;
    }
  }

}
.inner-wrapper {
  background: url("https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/wenli_bg.png") repeat;
}

.brand-info-head {
  height: 712px;
  position: relative;

  .head-nav {
    position: absolute;
    bottom: 40px;
    left: 0;
  }
}

.brand-info-content {
  min-height: 1088px;
  .md-container{
    width: 1400px;
    position: relative;
    min-height: 940px;
    .til{
      position: absolute;
      right: 0;
      top: 154px;
      background: url(https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/info_title.png) no-repeat top center;
      width: 266px;
      height: 631px;
    }
    .info-wrap{
      height: 100%;
      padding: 60px 0;
      box-sizing: border-box;
    }
    .info-list {
        list-style: none;
        margin: 0;
        overflow: hidden;
        width: 900px;
        padding: 0 0 0 24px;
        li {
          margin: 0;
          padding: 0;
          &:hover{
            border-bottom: 1px solid #473935;
          }
        }

        a {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 24px;
          line-height: 40px;
          color: #473935;
     
          .art-name {
            display: block;
            width: 720px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            text-align: left;
          }
        }
      }
  }
}
</style>